import React, { useState, useContext } from "react";
import logo from "../assets/images/ASK_-_JEEVES-01-removebg-preview (1).png";
import AskJeveevesAction from "../assets/videos/IMG_7756.mp4";
import askJveevesIntro from "../assets/videos/IMG_4940.mp4";
import { ContactUsModal } from "./ContactUsModal";
import { TbSend } from "react-icons/tb";
import { IoNewspaperOutline } from "react-icons/io5";
import { PatentContext } from "../context/PatentContextProvider";
import { useNavigate } from "react-router-dom";
import BBBlogo from "../assets/images/footerlogo (1).png";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

const LaunchingSoon = () => {
  const navigate = useNavigate();
  const { setPatentLicensingModal } = useContext(PatentContext)

  const [openVideo, setOpenVideo] = useState(false);
  const [video, setVideo] = useState();

  const handleContactUsModal = () => {
    setPatentLicensingModal(true);
  };

  const handleOpenVideo = (title) => {
    console.log("title", title)
    setOpenVideo(true)
    if (title === "askjeevesintro") {
      setVideo(askJveevesIntro)
    } else {
      setVideo(AskJeveevesAction)
    }
  }

  return (
    <>
      <div>
        <section
          className=" w-full bg-gradient-to-t min-h-screen from-[#16608f]/80 via-[#c7b7cf]/80 to-[#8f5969]/80
        overflow-y-auto"
        >
          <div className="mx-2 mt-2 px-2 flex  items-center md:justify-end lg:gap-5 justify-between">
            <button
              type="button"
              onClick={handleContactUsModal}
              className="
      group relative inline-flex items-center gap-2
      whitespace-nowrap
      rounded-xl border border-black/10
      bg-[#186496] px-6 py-2.5
      text-sm font-semibold text-white
      backdrop-blur-md
      w-1/2 sm:w-auto justify-center
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#b74c52]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer
    "
            >
              <TbSend size={18} />
              <span >Drop us a line</span>
            </button>
            <div className="mx-1">
              <img src={BBBlogo} />
            </div>
            <div>
            
            </div>
            
          </div>
          {/* 🔥 Vertical lines overlay */}
          <div className="pointer-events-none absolute inset-0 bg-[repeating-linear-gradient(90deg,rgba(255,255,255,0.09),rgba(255,255,255,0.09)_3px,transparent_4px,transparent_100px)]" />
          <div className="relative z-10 flex  flex-col items-center justify-center px-6 text-center mt-36">
            {/* Logo */}
            <img
              src={logo}
              alt="Ask Jeeves IP"
              className="mx-auto mb-4 w-64 md:w-72"
              loading="lazy"
            />

            {/* Heading */}
            <h2
              className="text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight
             bg-gradient-to-r from-[#17548d] via-[#1d5080] to-black/40
             bg-clip-text text-transparent pb-3"
            >
              Launching <span className="text-[#8b5062]">Soon</span>
            </h2>
            <p className="sr-only">The original concierge evolved. Access the new Ask Jeeves AI flagship for smarter search and digital assistance. A 1996 icon reimagined for 2026.</p>
            {/* Actions */}
            {/* <div className="relative mt-14 flex flex-col flex-wrap sm:flex-row items-center justify-center gap-4 sm:gap-6"> */}
            <div className="relative mt-14 mb-16 grid grid-cols-2 xl:flex xl:flex-wrap items-center justify-center gap-4 sm:gap-6 w-full max-w-6xl mx-auto">
              <div className="absolute inset-0 -z-10 flex justify-center">
                <div className="h-20 w-96 rounded-full bg-white/20 blur-3xl" />
              </div>

              <button
                type="button"
                onClick={() => handleOpenVideo('askjeevesintro')}
                className="
                col-span-2
                md:col-span-1
      group relative inline-flex items-center gap-2
      whitespace-nowrap pl-7
      rounded-xl bg-[#186496]/90 px-6 py-3.5
      text-sm font-semibold text-white
      w-full sm:w-auto justify-center
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#b74c52]
      hover:shadow-[0_18px_45px_rgba(183,76,82,0.45)]
      focus:outline-none cursor-pointer
    "
              >
                <span className="absolute inset-0 rounded-xl bg-white/10 opacity-0 transition-opacity group-hover:opacity-100" />

                <svg
                  className="relative h-6 w-6 transition-transform duration-300 group-hover:scale-110"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M8 5v10l7-5-7-5z" />
                </svg>

                <span className="relative">Jeeves from the past, to the Future</span>
              </button>

              <button
                type="button"
                onClick={() => handleOpenVideo('jeevesaction')}
                className="
                col-span-2
                md:col-span-1
      group relative inline-flex items-center gap-2
      whitespace-nowrap pl-7
      rounded-xl bg-[#186496]/90 px-6 py-3.5
      text-sm font-semibold text-white
      w-full sm:w-auto justify-center
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#b74c52]
      hover:shadow-[0_18px_45px_rgba(183,76,82,0.45)]
      focus:outline-none cursor-pointer
    "
              >
                <span className="absolute inset-0 rounded-xl bg-white/10 opacity-0 transition-opacity group-hover:opacity-100" />

                <svg
                  className="relative h-6 w-6 transition-transform duration-300 group-hover:scale-110"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M8 5v10l7-5-7-5z" />
                </svg>

                <span className="relative">Jeeves in action</span>
              </button>

            
              <div className="relative md:col-span-1 col-span-2 xl:col-span-1 flex justify-center ">
                <button
                  type="button"
                  onClick={() => navigate("/seven-pillars")}
                  className="
                  
       relative inline-flex gap-2.5
      whitespace-nowrap
      rounded-xl border border-black/10
      bg-[#186496] px-6 py-3.5
      text-sm font-semibold text-white
      backdrop-blur-md
      w-full sm:w-auto justify-center
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#b74c52]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer
    "
                >
                  <div className="flex justify-center items-center gap-2">
                    <IoNewspaperOutline size={18} />
                    <span>O'Hanlon Center of Excellence.</span>
                  </div>
                </button>
              </div>

              <Menu as="div" className="relative md:col-span-1 col-span-2 xl:col-span-1 flex justify-center">
                <MenuButton className="inline-flex group items-center gap-2 group relative whitespace-nowrap pl-7
      rounded-xl bg-[#186496]/90 px-6 py-3.5
      text-sm font-semibold text-white
      transition-all duration-300
      w-full sm:w-auto justify-center

      hover:-translate-y-0.5 hover:bg-[#b74c52]
      hover:shadow-[0_18px_45px_rgba(183,76,82,0.45)]
      focus:outline-none cursor-pointer">
                  Press Release
                  <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                </MenuButton>

                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-12 w-56 origin-top-left rounded-md bg-[#186496]/100 outline-[#186496]/100 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
                >
                  <div className="py-1 w-full">
                    <MenuItem>
                      <a
                        href="https://investorshangout.com/kenneth-ohanlon-pioneering-the-future-of-digital-innovation-509688-/"
                        target="_blank"
                        className="block px-1 py-2 text-sm text-white data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden
                    hover:bg-white/15"
                      >
                        Pioneering the Future of Digital Innovation - Investors Hangout
                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="https://sg.finance.yahoo.com/news/inner-circle-acknowledges-kenneth-ohanlon-172800269.html?guccounter=1"
                        target="_blank"
                        className="block px-1 py-2 text-sm text-white data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden hover:bg-white/15"
                      >
                        The Inner Circle acknowledges Kenneth O'Hanlon
                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="https://feature.marquiswhoswho.com/MWW_WSJ_Western_February12_2026"
                        target="_blank"
                        className="block px-1 py-2 text-sm text-white data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden hover:bg-white/15"
                      >
                        Marquis who's who
                      </a>
                    </MenuItem>
                  </div>
                </MenuItems>
              </Menu>
            </div>
          </div>
          <div className="fixed w-full font-semibold  bottom-0 bg-white/15">
            <div className="flex justify-center  items-center">
              <span className="py-2">© 2026 AskJeeves. All Rights Reserved</span>
            </div>
          </div>
        </section>

        {/* Video Modal */}
        {openVideo && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
            onClick={() => setOpenVideo(false)}
          >
            <div
              className="relative mx-4 w-full max-w-6xl rounded-2xl border border-[#121315]/40 bg-[#121315]/30 backdrop-blur-md shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close */}
              <button
                onClick={() => setOpenVideo(false)}
                aria-label="Close video"
                className="absolute -right-4 -top-4 flex h-9 w-9 items-center justify-center rounded-full bg-[#b54950] text-white font-bold shadow-lg transition hover:scale-105 cursor-pointer"
              >
                ✕
              </button>

              {/* Video */}
              <video
                src={video}
                controls
                autoPlay
                className="w-full rounded-2xl"
              />
            </div>

          </div>
        )}

        <ContactUsModal />
      </div>
    </>
  );
};

export default LaunchingSoon;